<template>
  <div class>
    <el-row :gutter="20">
      <el-col :span="12">
        <span style="text-align: left; margin-right: 20px">{{
          blindName
        }}</span>
        <el-button
          type="primary"
          icon="el-icon-refresh-right"
          size="mini"
          style="text-align: left"
          @click="goBack"
          >返回</el-button
        >
      </el-col>
      <el-col :span="12" class="btn">
        <div>
          <el-button
            type="primary"
            icon="el-icon-folder-add"
            size="small"
            @click="goAutoTest"
            >自动测试</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="addSubjects"
            >添加受试者</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-delete"
            size="small"
            @click="handleEmptyData"
            >清空数据</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        ref="filterTable"
        stripe
        border
        size="mini"
        :data="manualData"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column
          prop="random_code_combination"
          label="随机号"
          width="90"
        />
        <el-table-column
          prop="choice_code_combination"
          label="筛选号"
          width="90"
        />
        <el-table-column prop="name_abb" label="姓名缩写" width="90"/>
        <el-table-column prop="unit_name" label="单位名称"   />
        <el-table-column prop="layer_str" label="分层代码" v-if="projectDetail.is_need_layer" />
        <el-table-column prop="section_number" label="区段号"  />
        <el-table-column prop="group_name" label="试验组名" min-width="120"  />
      </el-table>
    </div>
    <!--分页-->
    <div class="pages">
      <el-pagination
        samll
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--添加受试者-->
    <el-dialog
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="45%"
      @close="handleCloseClick"
    >
      <div slot="title" class="title">添加受试者</div>
      <div class="proInfo">
        <el-row class="row">
          <el-col :span="4" class="left">中心：</el-col>
          <el-col :span="8">
            <el-select
              style="width: 100%"
              v-model="unit_id"
              placeholder="请选择"
              size="mini"
              @change="getMain"
            >
              <el-option
                v-for="item in centerList"
                :key="item.value"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-col>
        </el-row>
        <!--<el-row class="row">-->
        <!--<el-col :span="4" class="left">主要研究者：</el-col>-->
        <!--<el-col :span="18">-->
        <!--<el-select v-model="doctor_id" placeholder="请选择" size="mini">-->
        <!--<el-option-->
        <!--v-for="item in researcherList"-->
        <!--:key="item.value"-->
        <!--:label="item.name"-->
        <!--:value="item.id"-->
        <!--/>-->
        <!--</el-select>-->
        <!--</el-col>-->
        <!--</el-row>-->
        <el-row v-if="!front" class="row">
          <el-col :span="4" class="left">筛选号：</el-col>
          <el-col :span="8">
            <el-input v-model="choice_code" size="mini" type="text" />
          </el-col>
        </el-row>
        <el-row v-if="!after" class="row">
          <el-col :span="4" class="left">随机号：</el-col>
          <el-col :span="8">
            <el-input v-model="random_code" size="mini" type="text" />
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="4" class="left">姓名缩写：</el-col>
          <el-col :span="8">
            <el-input v-model="name_abb" size="mini" type="text" />
          </el-col>
        </el-row>
        <template v-if="projectDetail.is_need_layer">
          <el-row v-for="(items, index) in layer_list" :key="index" class="row">
            <el-col :span="4" class="left">{{ items.name }}：</el-col>
            <el-col :span="8">
              <el-select
                style="width: 100%"
                v-model="layer[items.id]"
                value-key="item.id"
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="item in items.list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.ids"
                />
              </el-select>
            </el-col>
          </el-row>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          size="mini"
          type="primary"
          @click="handleAdd"
          >确 定</el-button
        >
        <el-button size="mini" @click="handleCloseClick">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUnitNo } from "@/api/proUser";
import { manualTest, cleanData } from "@/api/test";
import { projectDetailApi } from "@/api/project";
import { getProjectId, getAfter, getFront } from "@/utils/auth";
import { detailPro } from "@/api/platform";
import { researchAll } from "@/api/company";
import { mainUser, add } from "@/api/subjects";

export default {
  name: "BlindTest",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: null,
      proId: "",
      dialogVisible: false,
      companyList: [],
      manualData: [],
      unit_id: "",
      doctor_id: "",
      choice_code: "",
      random_code: "",
      layer_list: [],
      centerList: [],
      researcherList: [],
      layer: {},
      newObj: {},
      name_abb: "",
      bindId: "",
      blindName: "",
      front: true,
      after: true,
      projectDetail: {},
    };
  },
  created() {
    this.proId = getProjectId();
    // this.after = (getAfter() === 'true')
    // this.front = (getFront() === 'true') // 转化为布尔
    // console.log(this.after)
    projectDetailApi(this, this.proId, (res) => {
      if (res && res.code === 0) {
        this.projectDetail = res.data;
        console.log('res---------->',res)
      }
    });
    // console.log(this.front)

    this.bindId = this.$route.query.id;
    this.blindName = this.$route.query.name;
    console.log(this.blindName);
    this.getManualTest();
    // this.getCompany()
    this.researchAll();
  },
  methods: {
    getMain(val) {
      console.log(val);
      this.getReasher(val);
    },
    // 研究者
    getReasher(id) {
      const params = {
        project_id: this.proId,
        unit_id: id,
      };
      mainUser(params)
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.researcherList = res.data;
            } else {
              this.researcherList = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    getManualTest() {
      const params = {
        project_id: this.proId,
        key: this.key,
        page: this.currentPage - 1,
        page_size: this.pageSize,
        blind_id: this.bindId,
      };
      manualTest(params)
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.manualData = res.data;
              this.total = res.total;
            } else {
              this.manualData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleAdd() {
      for (const key in this.layer) {
        this.newObj[key] = this.layer[key];
      }
      const params = {
        project_id: this.proId,
        unit_id: this.unit_id,
        doctor_id: this.doctor_id,
        name_abb: this.name_abb,
        layer_dict: this.newObj,
        choice_code: this.choice_code,
        random_code: this.random_code,
        is_test: true,
        blind_id: this.bindId,
      };
      add(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.handleCloseClick();
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleCloseClick() {
      this.dialogVisible = false;
      this.unit_id = "";
      this.random_code = "";
      this.name_abb = "";
      this.choice_code = "";
      this.layer = {};
      this.getManualTest();
    },
    // getCompany() {
    //   getUnitNo({ project_id: this.proId }).then(res => {
    //     if (res && res.code === 0) {
    //       if (res.data && res.data.length > 0) {
    //         this.companyList = res.data.map(item => {
    //           const obj = {}
    //           obj.label = item.style
    //           obj.value = item.id
    //           return obj
    //         })
    //       }
    //     } else {
    //       this.$message(res.msg)
    //     }
    //   }).catch(res => {
    //     console.log(res.msg)
    //   })
    // },
    // 中心
    researchAll() {
      researchAll({ project_id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.centerList = res.data;
            } else {
              this.centerList = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    goBack() {
      this.$router.push({
        path: "/blindFundus/index",
      });
    },
    // 切换至自动测试
    goAutoTest() {
      this.$router.push({
        path: "/test/blindAutomaticTest",
        query: {
          id: this.bindId,
          name: this.blindName,
        },
      });
    },
    // 清空数据
    handleEmptyData() {
      if (this.manualData != "") {
        this.$confirm(
          `是否确认 <span style="color: #698CFC;font-size: 14px;font-weight: bold;">清空数据</span>?`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            cancelButtonClass: "btn-custom-cancel",
            center: true,
            type: "warning",
          }
        )
          .then(() => {
            const param = {
              project_id: this.proId,
              method: "手动测试",
              blind_id: this.bindId,
            };
            cleanData(param)
              .then((res) => {
                if (res && res.code === 0) {
                  this.getManualTest();
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                } else {
                  this.$message(res.msg);
                }
              })
              .catch((res) => {
                console.log(res.msg);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },
    addSubjects() {
      this.dialogVisible = true;
      detailPro({ id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            this.front = res.data.is_choice_code_system;
            this.after = res.data.is_random_code_system;
            this.layer_list = res.data.layer_list.map((item) => {
              const obj = {};
              obj.name = item.name;
              obj.id = item.id;
              obj.list = item.item_list.map((i) => {
                const a = {};
                a.name = i.name;
                a.ids = i.id;
                return a;
              });
              return obj;
            });
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getManualTest();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getManualTest();
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;";
      }
    },
  },
};
</script>

<style scoped>
.btn {
  text-align: right;
}
.container-table {
  margin-top: 20px;
}
.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
.proInfo {
  background-color: #f0f5ff;
  padding: 20px 30px;
}
.proInfo .row {
  display: flex;
  align-items: center;
  justify-content: center;
}
.row {
  margin: 20px 0;
  font-size: 14px;
  color: #595959;
}
.left {
  line-height: 26px;
}
.pages {
  margin-top: 30px;
  text-align: right;
}
.edit {
  font-size: 12px;
  margin-right: 10px;
}
.desc {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 5px;
  text-align: center;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}
.container-table {
  border: 1px solid #e5eeff;
}
.el-tooltip__popper.is-light {
  border: none;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}
.popper__arrow {
  border: none !important;
}

.btn-custom-cancel {
  /* float: right; */
  margin-left: 10px;
}
.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}
.diaBg {
  background-color: #f0f5ff;
  padding: 20px;
}
.el-message-box .el-message-box__btns {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
}
</style>
